import { StyleSheet } from 'react-native'
import { Dialog, Portal, Text } from 'react-native-paper'
import { useDismissOnEscape } from '@/hooks/useDismissOnEscape'
import { Button } from '@/ui/Button'

interface DeleteLocationDialogProps {
    visible: boolean
    locationName: string
    onDismiss: () => void
    onConfirm: () => void
    isDeleting: boolean
    errorMessage?: string | null
}

export function DeleteLocationDialog({
    visible,
    locationName,
    onDismiss,
    onConfirm,
    isDeleting,
    errorMessage,
}: DeleteLocationDialogProps) {
    useDismissOnEscape(visible, onDismiss)

    return (
        <Portal>
            <Dialog visible={visible} onDismiss={onDismiss}>
                <Dialog.Title>Delete Location</Dialog.Title>
                <Dialog.Content>
                    <Text style={styles.message}>
                        Are you sure you want to delete the location "{locationName}"? Any related
                        time entries and movement records will be reassigned to another location for
                        this job.
                    </Text>
                    {errorMessage ? <Text style={styles.error}>{errorMessage}</Text> : null}
                </Dialog.Content>
                <Dialog.Actions>
                    <Button title="Cancel" onPress={onDismiss} disabled={isDeleting} />
                    <Button
                        title="Delete"
                        onPress={onConfirm}
                        loading={isDeleting}
                        disabled={isDeleting}
                    />
                </Dialog.Actions>
            </Dialog>
        </Portal>
    )
}

const styles = StyleSheet.create({
    message: {
        marginBottom: 8,
    },
    error: {
        marginTop: 8,
        color: '#d32f2f',
    },
})
